
import React from 'react';
import { MoreVertical, Edit, CheckCircle } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface EventOptionsMenuProps {
  eventId: string;
  isHost: boolean;
  status: string;
  onEdit?: () => void;
  onRsvp?: () => void;
}

export const EventOptionsMenu = ({ 
  eventId, 
  isHost, 
  status, 
  onEdit, 
  onRsvp 
}: EventOptionsMenuProps) => {
  const navigate = useNavigate();
  
  // Hide menu for confirmed/booked events
  if (status === 'confirmed' || status === 'booked') {
    return null;
  }

  const handleRsvp = () => {
    if (onRsvp) {
      onRsvp();
    } else {
      navigate(`/events/${eventId}/rsvp`);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8 p-0">
          <MoreVertical className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {isHost && (
          <DropdownMenuItem onClick={onEdit}>
            <Edit className="h-4 w-4 mr-2" />
            Edit Event
          </DropdownMenuItem>
        )}
        {/* Show RSVP option for all users, including hosts */}
        <DropdownMenuItem onClick={handleRsvp}>
          <CheckCircle className="h-4 w-4 mr-2" />
          RSVP
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
